module.exports = __webpack_public_path__ + "static/media/wi-owm-804.32167d49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather-svg/wi-owm-804.svg
// module id = 842
// module chunks = 0